import Cashier from './Cashier';

export default Cashier;